
import axios from 'axios';
export const flowService = {
    getEventGroupTree,
    
};

function getEventGroupTree(params) {
    return axios.get('Tracking/EventGroupTree', {params:params})
        .then(handleResponse)
        .catch(error => {
            return Promise.reject(error);
        });
}

function handleResponse(response) {
    if (response.data.Errors && response.data.Errors.length>0){
        // TODO handle error
        return Promise.reject(response.data.Errors[0]);
    }
    return Promise.resolve(response.data.Data);
}